/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { SectionGrid } from "frontend/src/components/Layout"
import { useState } from "react"

/* The main function */
function Iframe({ title, layout, url, offsetHeight, scrollHeight }) {
  /* iframe height as a state hook */
  const [height, setHeight] = useState()
  const offset = offsetHeight && offsetHeight !== "" ? offsetHeight : "offsetHeight"
  const scroll = scrollHeight && scrollHeight !== "" ? scrollHeight : "scrollHeight"
  /* function to change height automatically */
  const findHeight = e => {
    const heights = []
    if (e.data.hasOwnProperty(offset)) {
      heights.push(e.data[offset])
    }
    if (e.data.hasOwnProperty(scroll)) {
      heights.push(e.data[scroll])
    }
    if (heights.length > 0) {
      const maxHeight = Math.max(...heights)
      setHeight(`${maxHeight + 30}px`)
    }
  }
  /* call height function automatically if a message from the embedded site is
  received, see
  https://medium.com/better-programming/how-to-automatically-resize-an-iframe-7be6bfbb1214
  */
  try {
    window.onmessage = e => findHeight(e)
  } catch (error) {
    // console.log(error)
  }
  /* container */
  return (
    <SectionGrid>
      {layout === "full" && (
        <div sx={{ gridColumn: "1/span 5", width: "100%", height: "100%" }}>
          <iframe
            title={title}
            src={url}
            height={height}
            scrolling="no"
            sx={{
              width: "100%",
              border: "none",
            }}
          ></iframe>
        </div>
      )}
      {layout === "wide" && (
        <SectionGrid.wide>
          <iframe
            title={title}
            src={url}
            height={height}
            scrolling="no"
            sx={{ width: "100%", border: "none" }}
          ></iframe>
        </SectionGrid.wide>
      )}
      {layout === "narrow" && (
        <SectionGrid.narrow>
          <iframe
            title={title}
            src={url}
            height={height}
            scrolling="no"
            sx={{ width: "100%", border: "none" }}
          ></iframe>
        </SectionGrid.narrow>
      )}
    </SectionGrid>
  )
}

export { Iframe }
